// extracted by mini-css-extract-plugin
module.exports = {"item":"ServicesListItem_item__Pr_vX","captions":"ServicesListItem_captions__bZoX9"};